export const getIsImageEnlargeable = (imgUrl: string, defaultImage: string, disablePopup: boolean) =>
	imgUrl !== defaultImage && !disablePopup;
